// Event names for Mixpanel tracking
// Use these constants to ensure consistency across the app.

export const MIXPANEL_PROPS = {
  PAGE: "page",
  PAGE_NAME: "page_name",
  FEATURE: "feature",
  ACTION: "action",
  TAB: "tab",
  SOURCE: "source",

  // User details
  USER_ID: "user_id",
  USER_EMAIL: "email",
  USER_ROLE: "role",
  PLAN: "plan",
  USER_TYPE: "user_type",
  APP: "app",

  // Entities
  PERSON_ID: "person_id",
  PERSON_NAME: "person_name",
  PERSON_ROLE: "person_role",
  COMPARE_PERSON_ID: "compare_person_id",
  ENTITY_TYPE: "entity_type",
  COMPANY_NAME: "company_name",
  COMPANY_ID: "company_id",

  // Queries / Search
  QUERY: "query",
  SEARCH_TERM: "search_term",
  RESULT_COUNT: "result_count",
  FISCAL_YEAR: "fiscal_year",

  // Navigation
  SECTION: "section",
  SUBSECTION: "subsection",
  LOCATION: "location",

  // Metadata
  TIMESTAMP: "timestamp",
  OPTION: "option",
  SEARCH_FOR_OPTION: "search_for_option",
  RESULT_SELECTED: "result_selected",
  FILTER_OPTION: "filter_option",
  FILTER_CATEGORY: "filter_category",

  TAB_NAME: "tab_name",
  TAB_ENTITY_TYPE: "tab_entity_type",
  FILTER_NAME_TYPE: "filter_type_name",

  // Company Details
  REPORT_TYPE: "report_type",
  REPORT_YEAR: "report_year",
};

export const APPS = {
  OPEN_DIRECTOR: "Open Director",
  OPEN_REMUNERATION: "Open Remuneration",
};

export const OPEN_DIRECTOR_EVENT_NAMES = {
  PAGE_CLICKED: "Open Director Page Clicked",
  FEATURE_CLICKED: "Open Director Feature Clicked",
};

export const OPEN_REMUNERATION_EVENT_NAMES = {
  PAGE_CLICKED: "Open Rem Page Clicked",
  FEATURE_CLICKED: "Open Rem Feature Clicked",
};

export const GLOBAL_SEARCH_EVENT_NAMES = {
  OR_SEARCH_OPTION_CLICKED: "Open Rem Global Search Option Clicked",
  OD_SEARCH_OPTION_CLICKED: "Open Director Global Search Option Clicked",

  OR_SEARCH_RESULT_CLICKED: "Open Rem Global Search Result Clicked",
  OD_SEARCH_RESULT_CLICKED: "Open Director Global Search Result Clicked",
};

export const LINKEDIN_EVENT_NAMES = {
  OR_LINKEDIN_CLICKED: "Open Rem View LinkedIn Clicked",
  OD_LINKEDIN_CLICKED: "Open Director View LinkedIn Clicked",
};

export const DIRECTOR_EVENT_NAMES = {
  OR_DIRECTOR_PAGE_CLICKED: "Open Rem View Director Page Clicked",
  OD_DIRECTOR_PAGE_CLICKED: "Open Director View Director Page Clicked",
};

export const COMPANY_EVENT_NAMES = {
  OR_COMPANY_PAGE_CLICKED: "Open Rem View Company Page Clicked",
  OD_COMPANY_PAGE_CLICKED: "Open Director View Company Page Clicked",
};

export const HOMEPAGE_EVENT_NAMES = {
  OR_DASHBOARD_READ_ARTICLE_CLICKED: "Open Rem Read Article Clicked",
  OD_DASHBOARD_READ_ARTICLE_CLICKED: "Open Director Read Article Clicked",
};

// Organisations side bar

export const ORGANISATION_TAB_EVENT_NAMES = {
  OR_ORGANISATION_TAB_CLICKED: "Open Rem Organisation Tab Clicked",
  OD_ORGANISATION_TAB_CLICKED: "Open Director Organisation Tab Clicked",

  OR_ORGANISATION_LISTED_COMPANIES_TAB_CLICKED:
    "Open Rem Organisation Listed Companies Tab Clicked",
  OD_ORGANISATION_LISTED_COMPANIES_TAB_CLICKED:
    "Open Director Organisation Listed Companies Tab Clicked",

  OR_ORGANISATION_SUPERANNUATION_TAB_CLICKED:
    "Open Rem Organisation Superannuation Tab Clicked",
  OD_ORGANISATION_SUPERANNUATION_TAB_CLICKED:
    "Open Director Organisation Superannuation Tab Clicked",

  OR_ORGANISATION_GOVERNMENT_TAB_CLICKED:
    "Open Rem Organisation Government Tab Clicked",
  OD_ORGANISATION_GOVERNMENT_TAB_CLICKED:
    "Open Director Organisation Government Tab Clicked",

  OR_ORGANISATION_OTHER_GOVERNMENT_TAB_CLICKED:
    "Open Rem Organisation Other Government Tab Clicked",
  OD_ORGANISATION_OTHER_GOVERNMENT_TAB_CLICKED:
    "Open Director Organisation Other Government Tab Clicked",

  OR_ORGANISATION_NOT_FOR_PROFIT_TAB_CLICKED:
    "Open Rem Organisation Not For Profit Tab Clicked",
  OD_ORGANISATION_NOT_FOR_PROFIT_TAB_CLICKED:
    "Open Director Organisation Not For Profit Tab Clicked",

  OR_ORGANISATION_PRIVATE_COMPANIES_TAB_CLICKED:
    "Open Rem Organisation Private Companies Tab Clicked",
  OD_ORGANISATION_PRIVATE_COMPANIES_TAB_CLICKED:
    "Open Director Organisation Private Companies Tab Clicked",

  OR_ORGANISATION_ALL_TAB_CLICKED: "Open Rem Organisation All Tab Clicked",
  OD_ORGANISATION_ALL_TAB_CLICKED: "Open Director Organisation All Tab Clicked",

  OR_ORGANISATION_YOUR_COMPANY_TAB_CLICKED:
    "Open Rem Organisation Your Company Tab Clicked",
  OD_ORGANISATION_YOUR_COMPANY_TAB_CLICKED:
    "Open Director Organisation Your Company Tab Clicked",

  OR_ORGANISATION_YOUR_COMPANY_PEER_GROUP_DOWNLOAD_CLICKED:
    "Open Rem Organisation Your Company Peer Group Download Clicked",
  OD_ORGANISATION_YOUR_COMPANY_PEER_GROUP_DOWNLOAD_CLICKED:
    "Open Director Organisation Your Company Peer Group Download Clicked",
};

export const ORGANISATION_FILTER_EVENT_NAMES = {
  OR_ORGANISATION_FILTER_APPLIED: "Open Rem Organisation Filter Clicked",
  OD_ORGANISATION_FILTER_APPLIED: "Open Director Organisation Filter Clicked",
};

export const ORGANISATION_DOWNLOAD_EVENT_NAMES = {
  OR_DOWNLOAD_ALL_CLICKED: "Open Rem Download All Clicked",
  OD_DOWNLOAD_ALL_CLICKED: "Open Director Download All Clicked",
};

export const ORGANISATION_RISK_OF_CHANGE_EVENT_NAMES = {
  OR_RISK_OF_CHANGE_CLICKED: "Open Rem Risk Of Change Clicked",
  OD_RISK_OF_CHANGE_CLICKED: "Open Director Risk Of Change Clicked",
};

// Executive Remuneration Details
export const EXECUTIVE_REMUNERATION_DETAILS_EVENT_NAMES = {
  OR_EXECUTIVE_REMUNERATION_DETAILS_TAB_CLICKED: "Open Rem ERD Tab Clicked",
  OD_EXECUTIVE_REMUNERATION_DETAILS_TAB_CLICKED:
    "Open Director ERD Tab Clicked",

  OR_EXECUTIVE_REMUNERATION_DETAILS_COMPANY_NAME_SELECTED:
    "Open Rem ERD Company Name Selected",
  OD_EXECUTIVE_REMUNERATION_DETAILS_COMPANY_NAME_SELECTED:
    "Open Director ERD Company Name Selected",

  OR_EXECUTIVE_REMUNERATION_YEAR_CLICKED: "Open Rem ERD Year Clicked",
  OD_EXECUTIVE_REMUNERATION_YEAR_CLICKED: "Open Director ERD Year Clicked",

  OR_EXECUTIVE_REMUNERATION_ROLES_CLICKED: "Open Rem ERD Role Clicked",
  OD_EXECUTIVE_REMUNERATION_ROLES_CLICKED: "Open Director ERD Role Clicked",

  OR_EXECUTIVE_REMUNERATION_SEARCH_CLICKED: "Open Rem ERD Search Clicked",
  OD_EXECUTIVE_REMUNERATION_SEARCH_CLICKED: "Open Director ERD Search Clicked",

  OR_EXECUTIVE_REMUNERATION_PEER_ANALYSIS_TAB_CLICKED:
    "Open Rem ERD Peer Analysis Result Tab Clicked",
  OD_EXECUTIVE_REMUNERATION_PEER_ANALYSIS_TAB_CLICKED:
    "Open Director ERD Peer Analysis Result Tab Clicked",

  OR_EXECUTIVE_REMUNERATION_INDIVIDUAL_PACKAGE_DOWNLOAD_CLICKED:
    "Open Rem ERD Individual Package Download Clicked",
  OD_EXECUTIVE_REMUNERATION_INDIVIDUAL_PACKAGE_DOWNLOAD_CLICKED:
    "Open Director ERD Individual Package Download Clicked",
};

export const PROXY_ADVISOR_ESTIMATES_EVENT_NAMES = {
  OR_PROXY_ADVISOR_ESTIMATES_TAB_CLICKED:
    "Open Rem Proxy Advisor Estimates Tab Clicked",
  OD_PROXY_ADVISOR_ESTIMATES_TAB_CLICKED:
    "Open Director Proxy Advisor Estimates Tab Clicked",

  OR_PROXY_ADVISOR_ESTIMATES_COMPANY_SELECTED:
    "Open Rem Proxy Advisor Estimates Company Selected",
  OD_PROXY_ADVISOR_ESTIMATES_COMPANY_SELECTED:
    "Open Director Proxy Advisor Estimates Company Selected",

  OR_PROXY_ADVISOR_ESTIMATES_VIEW_PEER_GROUP_CLICKED:
    "Open Rem PAE View Peer Group Clicked",
  OD_PROXY_ADVISOR_ESTIMATES_VIEW_PEER_GROUP_CLICKED:
    "Open Director PAE View Peer Group Clicked",

  OR_PROXY_ADVISOR_ESTIMATES_ISS_RELATIVE_ALIGNMENT_CHARTS_CLICKED:
    "Open Rem PAE ISS Relative Alignment Charts Clicked",
  OD_PROXY_ADVISOR_ESTIMATES_ISS_RELATIVE_ALIGNMENT_CHARTS_CLICKED:
    "Open Director PAE ISS Relative Alignment Charts Clicked",

  OR_PROXY_ADVISOR_ESTIMATES_CGI_RELATIVE_ALIGNMENT_CHARTS_CLICKED:
    "Open Rem PAE CGI Relative Alignment Charts Clicked",
  OD_PROXY_ADVISOR_ESTIMATES_CGI_RELATIVE_ALIGNMENT_CHARTS_CLICKED:
    "Open Director PAE CGI Relative Alignment Charts Clicked",

  OR_PROXY_ADVISOR_ESTIMATES_OTHER_RELATIVE_ALIGNMENT_CHARTS_CLICKED:
    "Open Rem PAE Others Relative Alignment Charts Clicked",
  OD_PROXY_ADVISOR_ESTIMATES_OTHER_RELATIVE_ALIGNMENT_CHARTS_CLICKED:
    "Open Director PAE Others Relative Alignment Charts Clicked",

  OR_PROXY_ADVISOR_ESTIMATES_ISS_ABSOLUTE_ALIGNMENT_CHARTS_CLICKED:
    "Open Rem PAE ISS Absolute Alignment Charts Clicked",
  OD_PROXY_ADVISOR_ESTIMATES_ISS_ABSOLUTE_ALIGNMENT_CHARTS_CLICKED:
    "Open Director PAE ISS Absolute Alignment Charts Clicked",

  OR_PROXY_ADVISOR_ESTIMATES_CGI_ABSOLUTE_ALIGNMENT_CHARTS_CLICKED:
    "Open Rem PAE CGI Absolute Alignment Charts Clicked",
  OD_PROXY_ADVISOR_ESTIMATES_CGI_ABSOLUTE_ALIGNMENT_CHARTS_CLICKED:
    "Open Director PAE CGI Absolute Alignment Charts Clicked",

  OR_PROXY_ADVISOR_ESTIMATES_OTHER_ABSOLUTE_ALIGNMENT_CHARTS_CLICKED:
    "Open Rem PAE Others Absolute Alignment Charts Clicked",
  OD_PROXY_ADVISOR_ESTIMATES_OTHER_ABSOLUTE_ALIGNMENT_CHARTS_CLICKED:
    "Open Director PAE Others Absolute Alignment Charts Clicked",
};

// Board details

export const BOARD_DETAILS_EVENT_NAMES = {
  OR_BOARD_DETAILS_TAB_CLICKED: "Open Rem Board Details Tab Clicked",
  OD_BOARD_DETAILS_TAB_CLICKED: "Open Director Board Details Tab Clicked",

  OR_BOARD_DETAILS_INDIVIDUAL_COMPANY_SEARCH_CLICKED:
    "Open Rem Board Details Individual Company Search Clicked",
  OD_BOARD_DETAILS_INDIVIDUAL_COMPANY_SEARCH_CLICKED:
    "Open Director Board Details Individual Company Search Clicked",

  OR_BOARD_DETAILS_INDIVIDUAL_COMPANY_SEARCH_SELECTED:
    "Open Rem Board Details Individual Company Search Selected",
  OD_BOARD_DETAILS_INDIVIDUAL_COMPANY_SEARCH_SELECTED:
    "Open Director Board Details Individual Company Search Selected",

  OR_BOARD_DETAILS_PEER_ANALYSIS_SEARCH_CLICKED:
    "Open Rem Board Details Peer Analysis Search Clicked",
  OD_BOARD_DETAILS_PEER_ANALYSIS_SEARCH_CLICKED:
    "Open Director Board Details Peer Analysis Search Clicked",

  OR_BOARD_DETAILS_PEER_ANALYSIS_SEARCH_SELECTED:
    "Open Rem Board Details Peer Analysis Search Selected",
  OD_BOARD_DETAILS_PEER_ANALYSIS_SEARCH_SELECTED:
    "Open Director Board Details Peer Analysis Search Selected",

  OR_BOARD_DETAILS_PEER_ANALYSIS_RESULT_TAB_CLICKED:
    "Open Rem Board Details Peer Analysis Result Tab Clicked",
  OD_BOARD_DETAILS_PEER_ANALYSIS_RESULT_TAB_CLICKED:
    "Open Director Board Details Peer Analysis Result Tab Clicked",
};

//Power Search

export const POWER_SEARCH_EVENT_NAMES = {
  OR_POWER_SEARCH_PAGE_CLICKED: "Open Rem Power Search Page Clicked",
  OD_POWER_SEARCH_PAGE_CLICKED: "Open Director Power Search Page Clicked",

  OR_POWER_SEARCH_EXACT_KEYWORD_CLICKED:
    "Open Rem Power Search Exact Keyword Clicked",
  OD_POWER_SEARCH_EXACT_KEYWORD_CLICKED:
    "Open Director Power Search Exact Keyword Clicked",

  OR_POWER_SEARCH_INPUT_SEARCH_SELECTED:
    "Open Rem Power Search Input Search Selected",
  OD_POWER_SEARCH_INPUT_SEARCH_SELECTED:
    "Open Director Power Search Input Search Selected",

  OR_POWER_SEARCH_SEARCH_BUTTON_CLICKED:
    "Open Rem Power Search Search Button Clicked",
  OD_POWER_SEARCH_SEARCH_BUTTON_CLICKED:
    "Open Director Power Search Search Button Clicked",

  OR_POWER_SEARCH_APPLY_FILTER_CLICKED:
    "Open Rem Power Search Apply Filter Clicked",
  OD_POWER_SEARCH_APPLY_FILTER_CLICKED:
    "Open Director Power Search Apply Filter Clicked",

  OR_POWER_SEARCH_FULL_SCREEN_CLICKED:
    "Open Rem Power Search Full Screen Clicked",
  OD_POWER_SEARCH_FULL_SCREEN_CLICKED:
    "Open Director Power Search Full Screen Clicked",

  OR_POWER_SEARCH_FILTER_SOURCE_CLICKED:
    "Open Rem Power Search Filter Source Clicked",
  OD_POWER_SEARCH_FILTER_SOURCE_CLICKED:
    "Open Director Power Search Filter Source Clicked",

  OR_POWER_SEARCH_FILTER_CANDIDATE_STATUS_CLICKED:
    "Open Rem Power Search Filter Candidate Status Clicked",
  OD_POWER_SEARCH_FILTER_CANDIDATE_STATUS_CLICKED:
    "Open Director Power Search Filter Candidate Status Clicked",

  OR_POWER_SEARCH_FILTER_ROLE_CLICKED:
    "Open Rem Power Search Filter Role Clicked",
  OD_POWER_SEARCH_FILTER_ROLE_CLICKED:
    "Open Director Power Search Filter Role Clicked",

  OR_POWER_SEARCH_FILTER_SECTOR_CLICKED:
    "Open Rem Power Search Filter Sector Clicked",
  OD_POWER_SEARCH_FILTER_SECTOR_CLICKED:
    "Open Director Power Search Filter Sector Clicked",

  OR_POWER_SEARCH_FILTER_SKILLS_CLICKED:
    "Open Rem Power Search Filter Skills Clicked",
  OD_POWER_SEARCH_FILTER_SKILLS_CLICKED:
    "Open Director Power Search Filter Skills Clicked",

  OR_POWER_SEARCH_FILTER_RESIDENCY_CLICKED:
    "Open Rem Power Search Filter Residency Clicked",
  OD_POWER_SEARCH_FILTER_RESIDENCY_CLICKED:
    "Open Director Power Search Filter Residency Clicked",

  OR_POWER_SEARCH_FILTER_QUALIFICATIONS_CLICKED:
    "Open Rem Power Search Filter Qualifications Clicked",
  OD_POWER_SEARCH_FILTER_QUALIFICATIONS_CLICKED:
    "Open Director Power Search Filter Qualifications Clicked",

  OR_POWER_SEARCH_FILTER_GENDER_CLICKED:
    "Open Rem Power Search Filter Gender Clicked",
  OD_POWER_SEARCH_FILTER_GENDER_CLICKED:
    "Open Director Power Search Filter Gender Clicked",

  OR_POWER_SEARCH_FILTER_LISTED_COMPANY_CLICKED:
    "Open Rem Power Search Filter Listed Company Clicked",
  OD_POWER_SEARCH_FILTER_LISTED_COMPANY_CLICKED:
    "Open Director Power Search Filter Listed Company Clicked",

  OR_POWER_SEARCH_FILTER_MARKET_CAP_CLICKED:
    "Open Rem Power Search Filter Market Cap Clicked",
  OD_POWER_SEARCH_FILTER_MARKET_CAP_CLICKED:
    "Open Director Power Search Filter Market Cap Clicked",

  OR_POWER_SEARCH_FILTER_AGE_CLICKED:
    "Open Rem Power Search Filter Age Clicked",
  OD_POWER_SEARCH_FILTER_AGE_CLICKED:
    "Open Director Power Search Filter Age Clicked",

  OR_POWER_SEARCH_FILTER_TIME_IN_CURRENT_ROLE_CLICKED:
    "Open Rem Power Search Filter Time In Current Role Clicked",
  OD_POWER_SEARCH_FILTER_TIME_IN_CURRENT_ROLE_CLICKED:
    "Open Director Power Search Filter Time In Current Role Clicked",

  OR_POWER_SEARCH_FILTER_BASE_REMUNERATION_CLICKED:
    "Open Rem Power Search Filter Base Remuneration Clicked",
  OD_POWER_SEARCH_FILTER_BASE_REMUNERATION_CLICKED:
    "Open Director Power Search Filter Base Remuneration Clicked",

  OR_POWER_SEARCH_FILTER_TOTAL_REMUNERATION_CLICKED:
    "Open Rem Power Search Filter Total Remuneration Clicked",
  OD_POWER_SEARCH_FILTER_TOTAL_REMUNERATION_CLICKED:
    "Open Director Power Search Filter Total Remuneration Clicked",

  OR_POWER_SEARCH_PROFILE_CAREER_HISTORY_CLICKED:
    "Open Rem Power Search Profile Career History Clicked",
  OD_POWER_SEARCH_PROFILE_CAREER_HISTORY_CLICKED:
    "Open Director Power Search Profile Career History Clicked",

  OR_POWER_SEARCH_ADD_TO_LIST_CLICKED:
    "Open Rem Power Search Add To List Clicked",
  OD_POWER_SEARCH_ADD_TO_LIST_CLICKED:
    "Open Director Power Search Add To List Clicked",
};

// Worksheet

export const WORKSPACE_EVENT_NAMES = {
  OR_WORKSPACE_PAGE_CLICKED: "Open Rem Workspace Page Clicked",
  OD_WORKSPACE_PAGE_CLICKED: "Open Director Workspace Page Clicked",

  OR_WORKSPACE_DOWNLOAD_CLICKED: "Open Rem Workspace Download Clicked",
  OD_WORKSPACE_DOWNLOAD_CLICKED: "Open Director Workspace Download Clicked",
};

//consolidated network

export const CONSOLIDATED_NETWORK_EVENT_NAMES = {
  OR_CONSOLIDATED_NETWORK_ANALYSIS_PERSON_SELECTED:
    "Open Rem CNA Person Selected",
  OD_CONSOLIDATED_NETWORK_ANALYSIS_PERSON_SELECTED:
    "Open Director CNA Person Selected",

  OR_CONSOLIDATED_NETWORK_ANALYSIS_DOWNLOAD_CLICKED:
    "Open Rem CNA Download Clicked",
  OD_CONSOLIDATED_NETWORK_ANALYSIS_DOWNLOAD_CLICKED:
    "Open Director CNA Download Clicked",

  OR_CONSOLIDATED_NETWORK_ANALYSIS_TAB_CLICKED: "Open Rem CNA Tab Clicked",
  OD_CONSOLIDATED_NETWORK_ANALYSIS_TAB_CLICKED: "Open Director CNA Tab Clicked",

  OR_CONSOLIDATED_NETWORK_ANALYSIS_TAB_CLICKED: "Open Rem CNA Tab Clicked",
  OD_CONSOLIDATED_NETWORK_ANALYSIS_TAB_CLICKED: "Open Director CNA Tab Clicked",

  OR_CONSOLIDATED_NETWORK_ANALYSIS_LINK_WITH_OTHERS_PERSON_SELECTED:
    "Open Rem CNA Link With Others Person Selected",
  OD_CONSOLIDATED_NETWORK_ANALYSIS_LINK_WITH_OTHERS_PERSON_SELECTED:
    "Open Director CNA Link With Others Person Selected",
};

// executive remuneration comparison

export const EXECUTIVE_REMUNERATION_COMPARISON_EVENT_NAMES = {
  OR_EXECUTIVE_REMUNERATION_COMPARISON_STATUTORY_CLICKED:
    "Open Rem ER Statutory Clicked",
  OD_EXECUTIVE_REMUNERATION_COMPARISON_STATUTORY_CLICKED:
    "Open Director ER Statutory Clicked",

  OR_EXECUTIVE_REMUNERATION_COMPARISON_REMUNERATION_OPPORTUNITY_CLICKED:
    "Open Rem ER Remuneration Opportunity Clicked",
  OD_EXECUTIVE_REMUNERATION_COMPARISON_REMUNERATION_OPPORTUNITY_CLICKED:
    "Open Director ER Remuneration Opportunity Clicked",
};

// User Reports

export const USER_REPORTS_EVENT_NAMES = {
  OR_USER_REPORTS_DOWNLOAD_CLICKED: "Open Rem User Reports Download Clicked",
  OD_USER_REPORTS_DOWNLOAD_CLICKED:
    "Open Director User Reports Download Clicked",
};

//Non Executive Director Changes - Last 12 Months

export const NON_EXECUTIVE_DIRECTOR_CHANGES_EVENT_NAMES = {
  OR_NON_EXECUTIVE_DIRECTOR_CHANGES_TAB_CLICKED:
    "Open Rem NED Changes Tab Clicked",
  OD_NON_EXECUTIVE_DIRECTOR_CHANGES_TAB_CLICKED:
    "Open Director NED Changes Tab Clicked",

  OR_NON_EXECUTIVE_DIRECTOR_CHANGES_DOWNLOAD_CLICKED:
    "Open Rem NED Changes Download Clicked",
  OD_NON_EXECUTIVE_DIRECTOR_CHANGES_DOWNLOAD_CLICKED:
    "Open Director NED Changes Download Clicked",

  OR_NON_EXECUTIVE_DIRECTOR_CHANGES_INPUT_SEARCH_CLICKED:
    "Open Rem NED Changes Input Search Clicked",
  OD_NON_EXECUTIVE_DIRECTOR_CHANGES_INPUT_SEARCH_CLICKED:
    "Open Director NED Changes Input Search Clicked",
};

// Non Executive Directors Renewal

export const NON_EXECUTIVE_DIRECTORS_RENEWAL_EVENT_NAMES = {
  OR_NON_EXECUTIVE_DIRECTORS_RENEWAL_TAB_CLICKED:
    "Open Rem NED Renewal Tab Clicked",
  OD_NON_EXECUTIVE_DIRECTORS_RENEWAL_TAB_CLICKED:
    "Open Director NED Renewal Tab Clicked",

  OR_NON_EXECUTIVE_DIRECTORS_RENEWAL_YEAR_METRICS_CLICKED:
    "Open Rem NED Renewal Year Metrics Clicked",
  OD_NON_EXECUTIVE_DIRECTORS_RENEWAL_YEAR_METRICS_CLICKED:
    "Open Director NED Renewal Year Metrics Clicked",

  OR_NON_EXECUTIVE_DIRECTORS_RENEWAL_INPUT_SEARCH_CLICKED:
    "Open Rem NED Renewal Input Search Clicked",
  OD_NON_EXECUTIVE_DIRECTORS_RENEWAL_INPUT_SEARCH_CLICKED:
    "Open Director NED Renewal Input Search Clicked",

  OR_NON_EXECUTIVE_DIRECTORS_RENEWAL_DOWNLOAD_CLICKED:
    "Open Rem NED Renewal Download Clicked",
  OD_NON_EXECUTIVE_DIRECTORS_RENEWAL_DOWNLOAD_CLICKED:
    "Open Director NED Renewal Download Clicked",
};

// Executive Director Changes

export const EXECUTIVE_DIRECTOR_CHANGES_EVENT_NAMES = {
  OR_EXECUTIVE_DIRECTOR_CHANGES_DOWNLOAD_CLICKED:
    "Open Rem ED Changes Download Clicked",
  OD_EXECUTIVE_DIRECTOR_CHANGES_DOWNLOAD_CLICKED:
    "Open Director ED Changes Download Clicked",

  OR_EXECUTIVE_DIRECTOR_CHANGES_INPUT_SEARCH_CLICKED:
    "Open Rem ED Changes Input Search Clicked",
  OD_EXECUTIVE_DIRECTOR_CHANGES_INPUT_SEARCH_CLICKED:
    "Open Director ED Changes Input Search Clicked",
};

// Executive Departures/Arrivals

export const EXECUTIVE_DIRECTORS_DEPARTURES_ARRIVALS_EVENT_NAMES = {
  OR_EXECUTIVE_DIRECTORS_DEPARTURES_ARRIVALS_TAB_CLICKED:
    "Open Rem ED Departures/Arrivals Tab Clicked",
  OD_EXECUTIVE_DIRECTORS_DEPARTURES_ARRIVALS_TAB_CLICKED:
    "Open Director ED Departures/Arrivals Tab Clicked",

  OR_EXECUTIVE_DIRECTORS_DEPARTURES_ARRIVALS_INPUT_SEARCH_CLICKED:
    "Open Rem ED Departures/Arrivals Input Search Clicked",
  OD_EXECUTIVE_DIRECTORS_DEPARTURES_ARRIVALS_INPUT_SEARCH_CLICKED:
    "Open Director ED Departures/Arrivals Input Search Clicked",

  OR_EXECUTIVE_DIRECTORS_DEPARTURES_ARRIVALS_DOWNLOAD_CLICKED:
    "Open Rem ED Departures/Arrivals Download Clicked",
  OD_EXECUTIVE_DIRECTORS_DEPARTURES_ARRIVALS_DOWNLOAD_CLICKED:
    "Open Director ED Departures/Arrivals Download Clicked",
};

// Director Profile Details

export const DIRECTOR_PROFILE_DETAILS_EVENT_NAMES = {
  OR_DIRECTOR_PROFILE_BIO_CLICKED: "Open Rem Director Profile Bio Clicked",
  OD_DIRECTOR_PROFILE_BIO_CLICKED: "Open Director Director Profile Bio Clicked",

  OR_DIRECTOR_PROFILE_DOWNLOAD_SUMMARY_CLICKED:
    "Open Rem Director Profile Download Summary Clicked",
  OD_DIRECTOR_PROFILE_DOWNLOAD_SUMMARY_CLICKED:
    "Open Director Director Profile Download Summary Clicked",

  OR_DIRECTOR_PROFILE_ADD_TO_LIST_CLICKED:
    "Open Rem Director Profile Add To List Clicked",
  OD_DIRECTOR_PROFILE_ADD_TO_LIST_CLICKED:
    "Open Director Director Profile Add To List Clicked",

  OR_DIRECTOR_PROFILE_REMUNERATION_BREAKDOWN_CLICKED:
    "Open Rem Director Profile Remuneration Breakdown Clicked",
  OD_DIRECTOR_PROFILE_REMUNERATION_BREAKDOWN_CLICKED:
    "Open Director Director Profile Remuneration Breakdown Clicked",

  OR_DIRECTOR_PROFILE_DIRECTOR_LINKS_CLICKED:
    "Open Rem Director Profile Director Links Clicked",
  OD_DIRECTOR_PROFILE_DIRECTOR_LINKS_CLICKED:
    "Open Director Director Profile Director Links Clicked",
};

// Company Details

export const COMPANY_DETAILS_EVENT_NAMES = {
  OR_COMPANY_DETAILS_TAB_CLICKED: "Open Rem Company Directors Tab Clicked",
  OD_COMPANY_DETAILS_TAB_CLICKED: "Open Director Company Directors Tab Clicked",

  OR_COMPANY_DETAILS_REPORT_CLICKED:
    "Open Rem Company Directors Report Clicked",
  OD_COMPANY_DETAILS_REPORT_CLICKED:
    "Open Director Company Directors Report Clicked",

  OR_COMPANY_DETAILS_DOWNLOAD_CLICKED:
    "Open Rem Company Directors Download Clicked",
  OD_COMPANY_DETAILS_DOWNLOAD_CLICKED:
    "Open Director Company Directors Download Clicked",
};

// Company Executive Details

export const COMPANY_EXECUTIVE_DETAILS_EVENT_NAMES = {
  OR_COMPANY_EXECUTIVE_DETAILS_TAB_CLICKED:
    "Open Rem Company Executive Details Tab Clicked",
  OD_COMPANY_EXECUTIVE_DETAILS_TAB_CLICKED:
    "Open Director Company Executive Details Tab Clicked",

  OR_COMPANY_EXECUTIVE_DETAILS_REPORT_CLICKED:
    "Open Rem Company Executive Details Report Clicked",
  OD_COMPANY_EXECUTIVE_DETAILS_REPORT_CLICKED:
    "Open Director Company Executive Details Report Clicked",

  OR_COMPANY_EXECUTIVE_DETAILS_DOWNLOAD_CLICKED:
    "Open Rem Company Executive Details Download Clicked",
  OD_COMPANY_EXECUTIVE_DETAILS_DOWNLOAD_CLICKED:
    "Open Director Company Executive Details Download Clicked",
};
